module.exports = __webpack_public_path__ + "static/media/2-3.1d8a3ec1.png";